var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaDownloadAppBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 108,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cta-download-app-background_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h320v108H0z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M36 45C26.8 54.2 5.5 57.167-4 57.5L-16-12c61.333 1.333 182 5.4 174 11-10 7-39 14.5-67 14.5S47.5 33.5 36 45z",
    fill: "#00DCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.379 66.5c9.2-9.2 30.5-12.167 40-12.5l12 69.5c-61.333-1.333-182-5.4-174-11 10-7 39-14.5 67-14.5s43.5-20 55-31.5z",
    fill: "#FFEBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cta-download-app-background_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h320v108H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/cta-download-app-background.3bf28d46.svg";
export { SvgCtaDownloadAppBackground as ReactComponent };